import { createStoreContext } from '@/lib/zustand'

interface DialogState {
  onClose: VoidFunction
}

const { StoreProvider, useStore } = createStoreContext<DialogState, DialogState>({
  defaultState: ({ onClose }) => ({ onClose }),
})

export { StoreProvider as DialogProvider, useStore as useDialog }
